/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import SelectWithPagination from 'components/shared/dropdown-with-pagination/SelectWithPagination';
import { Spin, Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Tooltip } from 'react-bootstrap';

import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import classes from './SiteUtilization.module.scss';
import {
  resetSiteUtilizationFilters,
  setAllInsightView,
  setFilterInit,
  setInsightType,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
  setSiteLoader,
  setSiteUtilizationExpression,
} from 'store/customer/customerViewSlice';
import {
  SITE_UTILIZATION_UTILIZATION,
  SITE_UTILIZATION_INCIDENCE,
  SITE_UTILIZATION_DEMOGRAPHICS,
  SITE_UTILIZATION_COLUMNS,
  SITE_UTILIZATION_TIME_RANGE_EXP,
  SITE_UTILIZATION_FILTER_NAME,
  TABLE_NAME_SITE_UTILIZATION,
  SITE_UTILIZATION_HIGH_MEDIUM_LOW_COLUMN_NAME,
  FLAG,
  PAGINATION,
  INSIGHT_TYPE,
} from 'constants/constants';
import { getSiteUtilizationData } from 'store/customer/customer-view-actions';

import { getCustomerExpr, getRestrictedColumn, isArray } from 'utils/utils';
import { SITE_UTILIZATION_APP_ID } from 'constants/constants';

import { getQlikSenseData } from 'services/qlik.service';

import { useCallback } from 'react';
import ExportTables from './ExportTables';
import uuid from 'react-native-uuid';
import { useNavigate } from 'react-router-dom';
import styleVars from '../../../assets/styles/helpers/_vars.scss';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';

const SiteUtilization = () => {
  const selectedEcosystem = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters?.SiteUtilization_Ecosystem
        ?.selectedValue
  );
  const selectedSite = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters
        ?.SiteUtilization_SiteName_Address?.selectedValue
  );
  const selectedCity = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters?.SiteUtilization_SiteCity
        ?.selectedValue
  );
  const selectedState = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters?.SiteUtilization_SiteState
        ?.selectedValue
  );
  const selectedSiteAddress = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters?.SiteUtilization_Site_Address
        ?.selectedValue
  );
  const navigation = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const isExporting = useSelector(
    (state) => state?.CustomerView?.exportSiteUtilizaztion
  );
  const [fieldExpression, setFieldExpression] = useState();
  const [filteredColumns, setFilteredColumns] = useState(
    SITE_UTILIZATION_UTILIZATION
  );
  const [modalShow, setModalShow] = useState(false);

  const [allColumnData, setAllColumnData] = useState(SITE_UTILIZATION_COLUMNS);
  const [updatedColumnData, setupdatedColumnData] = useState(
    SITE_UTILIZATION_UTILIZATION
  );

  const dispatch = useDispatch();

  const qlikToken = localStorage.getItem('qlikToken');
  const qlikCookie = localStorage.getItem('qlikCookie');

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const [siteType, setSiteType] = useState('SiteUtilization');
  const [utilizationData, setUtilizationData] = useState([]);

  const ecosystemOptions = useSelector(
    (state) =>
      state?.CustomerView?.siteUtilizationFilters?.SiteUtilization_Ecosystem
  );

  const [size, setSize] = useState({ x: 3900, y: 400 });

  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );
  const [timeRange, setTimeRange] = useState('');

  const [selectRadioBtn, setSelectRadioBtn] = useState('SiteUtilization');
  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) {
      getSiteUtilizationTimeRange();
    }
  }, []);

  useEffect(() => {
    setSelectRadioBtn('SiteUtilization');
    setFilteredColumns(SITE_UTILIZATION_UTILIZATION);
    setSiteType('SiteUtilization');
    setSize({ x: 3900, y: 400 });
  }, [selectedCustomer]);

  let siteFilterExpression;

  const getSiteUtilizationTimeRange = async () => {
    const response = await getQlikSenseData(
      SITE_UTILIZATION_TIME_RANGE_EXP,
      null,
      SITE_UTILIZATION_APP_ID
    );
    setTimeRange(response.data.data.category[0].replaceAll("'", ' '));
  };

  const [firstLoad, setFirstLoad] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(PAGINATION.defaultPageSize);
  const [menuIsOpen, setMenuIsOpen] = useState({
    SiteUtilization_Ecosystem: false,
    SiteUtilization_SiteName_Address: false,
    SiteUtilization_SiteCity: false,
    SiteUtilization_SiteState: false,
    SiteUtilization_Site_Address: false,
  });
  const totalRecords =
    utilizationData?.length >= 0 && utilizationData?.length < 100
      ? utilizationData?.length
      : 100;

  const [total, setTotal] = useState(totalRecords);
  useEffect(() => {
    setTotal(totalRecords);
  }, [totalRecords]);

  const pagination = {
    total: total,
    onChange: (page, size) => {
      setPageIndex(page);
      setPageSize(size);
    },
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };
  useEffect(() => {
    if (!firstLoad) {
      let expression = buildExpression();
      getUtilizationData(expression, 0);
    }
  }, [siteType]);

  useEffect(() => {
    setPageIndex(pageIndex);
    const isLastPage = pageIndex === Math.ceil(total / pageSize);
    let expression = buildExpression();
    if (isLastPage && total < utilizationData.totalSize) {
      getUtilizationData(expression, pageIndex);

      setTotal(total + 100);
    }
  }, [pageIndex]);

  const buildExpression = () => {
    const isAllEcosystem =
      isArray(ecosystemOptions) &&
      ecosystemOptions?.length === selectedEcosystem?.length;

    const ecosystem = isAllEcosystem ? 'Ecosystem=' : selectedEcosystem;

    const accountExp = getCustomerExpr(
      selectedCustomer,
      isArray(selectedCustomer)
    );

    //build Ecosystem  expression
    const ecosystemExp = isArray(ecosystem)
      ? 'Ecosystem={"' + ecosystem.map((a) => a.label).join('","') + '"}'
      : '';

    const siteNameExp = isArray(selectedSite)
      ? 'Site_ID ={"' + selectedSite.map((a) => a.value).join('","') + '"}'
      : '';
    const siteCityExp = isArray(selectedCity)
      ? '[Site City] ={"' + selectedCity.map((a) => a.label).join('","') + '"}'
      : '';
    const siteStateExp = isArray(selectedState)
      ? '[Site State] ={"' +
        selectedState.map((a) => a.label).join('","') +
        '"}'
      : '';
    const siteAddressExp = isArray(selectedSiteAddress)
      ? '[Site Address] ={"' +
        selectedSiteAddress.map((a) => a.label).join('","') +
        '"}'
      : '';

    siteFilterExpression = `${accountExp}`;

    if (siteNameExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${siteNameExp}`);
    if (ecosystemExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${ecosystemExp}`);
    if (siteCityExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${siteCityExp}`);
    if (siteStateExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${siteStateExp}`);
    if (siteAddressExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${siteAddressExp}`);

    setFieldExpression(siteFilterExpression);
    dispatch(setSiteUtilizationExpression(siteFilterExpression));
    return siteFilterExpression;
  };

  const getUtilizationData = async (
    expression,
    pageIndex = 0,
    column = 'summary_score',
    order = 'desc'
  ) => {
    setIsLoading(true);
    let data = await getSiteUtilizationData(
      expression,
      siteType,
      pageIndex,
      qlikCookie,
      qlikToken,
      column,
      order
    );
    setUtilizationData(data?.values);
    setIsLoading(false);
    setFirstLoad(false);
  };

  useEffect(() => {
    if (!selectedCustomer?.label) {
      dispatch(setSiteLoader(false));
      return;
    }
    let expression = buildExpression();
    getUtilizationData(expression);
  }, [
    selectedCity,
    selectedSite,
    selectedState,
    selectedSiteAddress,
    selectedEcosystem,
    selectedCustomer?.value,
  ]);

  useEffect(() => {
    setAllColumnData(
      allColumnData?.map((item) => ({
        ...item,
        isSelected: filteredColumns?.some(
          (filterColumn) => filterColumn.dataIndex === item.dataIndex
        )
          ? 'Y'
          : 'N',
      }))
    );

    setupdatedColumnData(filteredColumns);
  }, [filteredColumns, modalShow]);

  const handleClick = (rowData, index) => {
    const payload = {
      value: rowData?.mdmId,
      label: rowData?.site_name,
      zip: rowData?.site_zip,
      flag: FLAG.site[0],
    };
    dispatch(setFilterInit());
    dispatch(setSeletedView('site'));
    dispatch(setSelectedCustomer(payload));
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
    dispatch(setSelectedInsightView({}));
    dispatch(setAllInsightView([]));
    navigation(`/customerView/list/${rowData?.site_name}`);
  };
  const handleSorting = (column, order) => {
    let expression = buildExpression();
    order = order === 'ascend' ? 'ASC' : order;
    getUtilizationData(expression, 0, column, order);
  };

  const onMenuOpen = useCallback((filterName, value) => {
    let menuIsOpenLocal = menuIsOpen;
    if (filterName !== '' && value) {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: filterName === key };
      }, {});
    } else if ((filterName !== '' && !value) || filterName === '') {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: false };
      }, {});
    }
    setMenuIsOpen({ ...menuIsOpenLocal });
  }, []);

  const handleoptionchange = (e) => {
    setSelectRadioBtn(e.target.value);
    if (e.target.value === 'SiteUtilization') {
      setFilteredColumns(SITE_UTILIZATION_UTILIZATION);
      setSize({ x: 3900, y: 400 });
      setSiteType('SiteUtilization');
    } else if (e.target.value === 'SiteIncidence') {
      setFilteredColumns(SITE_UTILIZATION_INCIDENCE);
      setSize({ x: 1900, y: 400 });
      setSiteType('SiteIncidence');
    } else if (e.target.value === 'SiteDemographic') {
      setFilteredColumns(SITE_UTILIZATION_DEMOGRAPHICS);
      setSize({ x: 1900, y: 400 });
      setSiteType('SiteDemographic');
    }
  };
  const ExportClickHandler = () => {
    setupdatedColumnData(filteredColumns);
    setModalShow(true);
  };
  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const resetFilters = () => {
    dispatch(resetSiteUtilizationFilters());
  };

  const onHide = () => {
    setModalShow(false);
    handleClearAll();
  };
  const handleClearAll = () => {
    setAllColumnData(
      allColumnData?.map((report) => {
        return {
          ...report,
          isSelected: 'N',
        };
      })
    );
    setupdatedColumnData([]);
  };

  const handleSelectAll = () => {
    setAllColumnData(
      allColumnData?.map((report) => {
        return {
          ...report,
          isSelected: 'Y',
        };
      })
    );
    setupdatedColumnData(allColumnData);
  };

  return (
    <div className={utilizationData?.length > 0 ? '' : 'pb-3'}>
      <div
        id='SiteUtilization'
        className='pt-3'>
        <Row className='pt-3'>
          <Col md={4}>
            <p
              className='title title__bold title__large mb-0'
              style={{ paddingRight: 0, marginRight: 0 }}>
              Site Utilization & Demographics
            </p>
            {<p className='title__small pt-0 text text__grey'>{timeRange}</p>}
          </Col>
          <Col
            md={6}
            style={{ paddingLeft: 0, marginLeft: 0 }}>
            <div
              className={`title__small ${classes['radio_selection']}`}
              style={{ paddingLeft: 0, marginLeft: 0 }}>
              <label className={classes['radio_button']}>
                <input
                  type='radio'
                  name='siteUtilizationRadioBtn'
                  value='SiteUtilization'
                  className={classes['radio_label']}
                  checked={selectRadioBtn === 'SiteUtilization'}
                  onChange={handleoptionchange}
                />
                Utilization
              </label>
              <label className={classes['radio_button']}>
                <input
                  type='radio'
                  name='siteUtilizationRadioBtn'
                  className={classes['radio_label']}
                  value='SiteIncidence'
                  checked={selectRadioBtn === 'SiteIncidence'}
                  onChange={handleoptionchange}
                />
                Incidence (Per 100K)
              </label>
              <label className={classes['radio_button']}>
                <input
                  type='radio'
                  name='siteUtilizationRadioBtn'
                  className={classes['radio_label']}
                  value='SiteDemographic'
                  checked={selectRadioBtn === 'SiteDemographic'}
                  onChange={handleoptionchange}
                />
                Demographics
              </label>
            </div>
          </Col>
          <Col
            className='d-flex justify-content-end mt-2'
            md={2}>
            <OverlayIcon
              tooltip={'Reset Filters'}
              onClick={resetFilters}
              className={`icon icon__reset-filters me-3`}
            />
            <OverlayTrigger overlay={exportTooltip}>
              <i
                onClick={ExportClickHandler}
                className={`icon icon__affiliations_export_excel1`}
              />
            </OverlayTrigger>
            {modalShow && (
              <ExportTables
                show={modalShow}
                modalshow={modalShow}
                onHide={onHide}
                allColumnData={allColumnData}
                setAllColumnData={setAllColumnData}
                updatedColumnData={updatedColumnData}
                setupdatedColumnData={setupdatedColumnData}
                handleClearAll={handleClearAll}
                handleSelectAll={handleSelectAll}
                expression={fieldExpression}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col
            md={12}
            className={'p-0 m-0'}>
            <Row>
              <Col md={3}>
                <label className='title__x-small'>Ecosystem</label>
                <SelectWithPagination
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={onMenuOpen}
                  filter={siteUtilizationFilters}
                  appid={SITE_UTILIZATION_APP_ID}
                  fieldName='SiteUtilization_Ecosystem'
                  isMulti={true}
                  filterName={SITE_UTILIZATION_FILTER_NAME}
                  cacheUniqs={[
                    selectedCity,
                    selectedSite,
                    selectedState,
                    selectedCustomer,
                    selectedSiteAddress,
                  ]}
                  expression={fieldExpression}
                  isDefault={false}
                />
              </Col>
              <Col md={2}>
                <label className='title__x-small'>Site Name</label>
                <SelectWithPagination
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={onMenuOpen}
                  filter={siteUtilizationFilters}
                  fieldName='SiteUtilization_SiteName_Address'
                  appid={SITE_UTILIZATION_APP_ID}
                  isMulti={true}
                  filterName={SITE_UTILIZATION_FILTER_NAME}
                  expression={fieldExpression}
                  cacheUniqs={[
                    selectedCity,
                    selectedEcosystem,
                    selectedState,
                    selectedCustomer,
                    selectedSiteAddress,
                  ]}
                />
              </Col>
              <Col md={3}>
                <label className='title__x-small'>Site Address</label>
                <SelectWithPagination
                  filter={siteUtilizationFilters}
                  fieldName='SiteUtilization_Site_Address'
                  isMulti={true}
                  appid={SITE_UTILIZATION_APP_ID}
                  isDefault={false}
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={onMenuOpen}
                  expression={fieldExpression}
                  filterName={SITE_UTILIZATION_FILTER_NAME}
                  cacheUniqs={[
                    selectedCity,
                    selectedEcosystem,
                    selectedSite,
                    selectedCustomer,
                    selectedState,
                  ]}
                />
              </Col>
              <Col md={2}>
                <label className='title__x-small'>Site City</label>
                <SelectWithPagination
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={onMenuOpen}
                  filter={siteUtilizationFilters}
                  fieldName='SiteUtilization_SiteCity'
                  appid={SITE_UTILIZATION_APP_ID}
                  isMulti={true}
                  filterName={SITE_UTILIZATION_FILTER_NAME}
                  cacheUniqs={[
                    selectedSite,
                    selectedEcosystem,
                    selectedState,
                    selectedCustomer,
                    selectedSiteAddress,
                  ]}
                  expression={fieldExpression}
                />
              </Col>
              <Col md={2}>
                <label className='title__x-small'>Site State</label>
                <SelectWithPagination
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={onMenuOpen}
                  filter={siteUtilizationFilters}
                  fieldName='SiteUtilization_SiteState'
                  isMulti={true}
                  appid={SITE_UTILIZATION_APP_ID}
                  filterName={SITE_UTILIZATION_FILTER_NAME}
                  cacheUniqs={[
                    selectedCity,
                    selectedEcosystem,
                    selectedSite,
                    selectedCustomer,
                    selectedSiteAddress,
                  ]}
                  expression={fieldExpression}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        &nbsp;
      </div>

      <Row
        id='SiteUtilizationTable'
        className={classes.sitePerformanceContainer}>
        <Col xs={12}>
          <Spin spinning={isLoading || isExporting}>
            <ConfigurableTable
              rows={utilizationData}
              columns={getRestrictedColumn(
                TABLE_NAME_SITE_UTILIZATION,
                filteredColumns,
                columnRestriction
              ).map((col) => {
                if (col.dataIndex === 'site_name') {
                  return {
                    ...col,
                    render: (text, record) => (
                      <span
                        className='span-link'
                        href={`/customerView/list/${record?.site_name}`}
                        onClick={() => handleClick(record)}>
                        {text}
                      </span>
                    ),
                  };
                } else if (col.dataIndex === 'summary_score') {
                  return {
                    ...col,
                    render: (text, record) => (
                      <Tag
                        color={
                          text >= 51 && text <= 80
                            ? styleVars.color_green
                            : text >= 36 && text <= 50
                              ? styleVars.color_yellow_2
                              : text >= 1 && text <= 35
                                ? styleVars.color_red_2
                                : ''
                        }
                        key={uuid.v4()}>
                        {text}
                      </Tag>
                    ),
                  };
                } else if (
                  SITE_UTILIZATION_HIGH_MEDIUM_LOW_COLUMN_NAME.includes(
                    col?.dataIndex
                  )
                ) {
                  return {
                    ...col,
                    render: (text, record) => (
                      <Tag
                        color={
                          text === 'High'
                            ? styleVars.color_green
                            : text === 'Medium'
                              ? styleVars.color_yellow_2
                              : text === 'Low'
                                ? styleVars.color_red_2
                                : ''
                        }
                        key={uuid.v4()}>
                        {text}
                      </Tag>
                    ),
                  };
                }
                return {
                  ...col,
                  width: col?.width ? col?.width : col?.title?.length * 18,
                };
              })}
              expandRowByClick={false}
              enableColumnSelection={false}
              enableExport={false}
              exportFileName='siteUtilizationDetails'
              tableName={TABLE_NAME_SITE_UTILIZATION}
              expression={siteFilterExpression}
              isGlobalExport={true}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleSorting}
              tableType={selectRadioBtn}
              dimentions={size}
            />
          </Spin>
        </Col>
      </Row>
    </div>
  );
};

export default SiteUtilization;
